var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetaOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 29,
    viewBox: "0 0 85 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Beta",
    transform: "translate(-808 -101.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1603",
    "data-name": "Rect\\xE1ngulo 1603",
    width: 85,
    height: 29,
    rx: 7,
    transform: "translate(808 101.226)",
    fill: "#d7664a"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BETA-2",
    "data-name": "BETA",
    transform: "translate(849 121.226)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22,
    y: 0
  }, "BETA")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaOrange);
export default __webpack_public_path__ + "static/media/beta_orange.a88644fcf5c3ba46deabd876ebb28a46.svg";
export { ForwardRef as ReactComponent };